import { Component, OnInit } from '@angular/core';
import QuotationDetailsHelper from './quotation-details.helper';
import { QuotationCommercialItem } from '../../models/quotable-items/quotation-commercial-item.model';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'dop-quotation-details',
  templateUrl: './quotation-details.component.html',
  styleUrls: ['./quotation-details.component.scss']
})
export class QuotationDetailsComponent implements OnInit {

  quotationDetails: QuotationCommercialItem;
  quotation: any;
  constructor(
    private ref: DynamicDialogRef,
    private config: DynamicDialogConfig
  ) {
    if (config.data.quotationDetails) {
      this.quotationDetails = config.data.quotationDetails;
    }
  }

  ngOnInit(): void {
    this.quotation = QuotationDetailsHelper.sortQuotableItems(this.quotationDetails);
  }
  closeDialog() {
    this.ref.close();
  }
}
